import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import ErrorLabel from "./errorLabel.tsx";

type Props = {
  name: string;
  placeholder?: string;
  prefix?: string;
};

export default function Input({ name, placeholder, prefix }: Props) {
  const { register } = useFormContext();

  return (
    <>
      <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-sky-600 sm:max-w-md">
        {prefix && (
          <span className="flex select-none items-center pl-3 text-gray-500 sm:text-sm">
            {prefix}
          </span>
        )}
        <input
          type="text"
          autoComplete="off"
          className="block flex-1 border-0 bg-transparent py-1.5 pl-3 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
          placeholder={placeholder}
          {...register(name)}
        />
      </div>
      <ErrorMessage
        name={name}
        render={({ message }) => <ErrorLabel message={message} />}
      />
    </>
  );
}
